module.exports = __webpack_public_path__ + "static/media/edinburgh-19.4c1cb651.jpg";